module.exports = __webpack_public_path__ + "static/img/fdi_logo2.e5e0afb2.jpg";